export const AppName = 'HomePage'
export const FeatureFlags = [
  'HomePage_FrontEnd_DisplayAudience',
  'Ribbon_Text_Dollar_Vs_Percentage',
]
export const ShouldUseClarityAutomate = false
